module.exports = __webpack_public_path__ + "static/BUS-web-homepage-2019-36456bf77c5a80245a46fcb43cc2ff18.png";